import React from "react";
import DashboardCardWithAnimatedValue from "../../../../reusable-components/cards/DashboardCardWithAnimatedValue";

const NocReportSummaryCard = ({
  data,
  setFilterText,
  isLoading,
  filterText,
}) => {
  return (
    <div className="grid w-full grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      {/* Today */}

      <DashboardCardWithAnimatedValue
        filterText={filterText}
        isLoading={isLoading}
        setFilterText={setFilterText}
        showRupeeSymbol={true}
        title="Today"
        value={data?.total_amount_today || 0}
        filterKey="today"
      />

      {/* Last 7 Days */}

      <DashboardCardWithAnimatedValue
        isLoading={isLoading}
        filterText={filterText}
        setFilterText={setFilterText}
        showRupeeSymbol={true}
        title="Last 7 Days"
        value={data?.total_amount_last_7_days || 0}
        filterKey="last_7_days"
      />

      {/* Last 30 Days */}

      <DashboardCardWithAnimatedValue
        isLoading={isLoading}
        filterText={filterText}
        setFilterText={setFilterText}
        showRupeeSymbol={true}
        title="Last 30 Days"
        value={data?.total_amount_last_30_days || 0}
        filterKey="last_30_days"
      />

      {/* Last 365 Days */}

      <DashboardCardWithAnimatedValue
        isLoading={isLoading}
        filterText={filterText}
        setFilterText={setFilterText}
        showRupeeSymbol={true}
        title="Last 365 Days"
        value={data?.total_amount_last_365_days || 0}
        filterKey="last_365_days"
      />

      {/* Total */}

      <DashboardCardWithAnimatedValue
        isLoading={isLoading}
        filterText={filterText}
        setFilterText={setFilterText}
        showRupeeSymbol={true}
        title="Total"
        value={data?.total_amount || 0}
        filterKey=""
      />
    </div>
  );
};

export default NocReportSummaryCard;
